import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { useLocation, useParams } from "wouter";
import { AtmosphericPage } from "@/components/MirrorAtmosphere";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [, setLocation] = useLocation();
  const params = useParams<{ token: string }>();
  const resetMutation = useMutation({
    mutationFn: async (data: { token: string; password: string }) =>
      (await apiRequest("POST", "/api/auth/reset-password", data)).json(),
    onSuccess: () => {
      setSuccess(true);
      setTimeout(() => setLocation("/auth"), 3000);
    },
    onError: (err: Error) =>
      setError(err.message.includes("400") ? "This reset link has expired or is invalid" : "Something went wrong. Try again."),
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!password || !confirmPassword) return setError("Both fields required");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    if (password !== confirmPassword) return setError("Passwords don't match");
    resetMutation.mutate({ token: params.token, password });
  };
  return (
    <AtmosphericPage testId="reset-password-page" atmosphere={{ immersive: true, fill: 0.88, count: 7600, opacityScale: 0.4 }}>
      <div className="mirror-auth-layout">
        <section className="mirror-auth-composition fade-in">
          <header className="mirror-auth-brand">
            <div className="mirror-auth-title">FRACTAL</div>
            <div className="mirror-auth-subtitle">set a new password</div>
          </header>
          <div className="mirror-auth-panel">
            {success ? (
              <p className="type-body" data-testid="text-password-updated">Password updated. Redirecting to sign in...</p>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="mirror-form-label" htmlFor="new-password">New password</label>
                  <input id="new-password" type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="input-new-password" className="mirror-form-input" placeholder="6+ characters" autoComplete="new-password" />
                </div>
                <div>
                  <label className="mirror-form-label" htmlFor="confirm-new-password">Confirm password</label>
                  <input id="confirm-new-password" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} data-testid="input-confirm-new-password" className="mirror-form-input" placeholder="again" autoComplete="new-password" />
                </div>
                {error && <p className="type-body text-center py-1" style={{ color: "var(--status-error)" }} data-testid="text-reset-password-error">{error}</p>}
                <button type="submit" disabled={resetMutation.isPending} data-testid="button-set-new-password" className="mirror-primary-action">
                  {resetMutation.isPending ? "..." : "Set new password"}
                </button>
              </form>
            )}
          </div>
        </section>
      </div>
    </AtmosphericPage>
  );
}